

































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { ICallbackBody, IMerchants, PayloadState } from '@/types/types';

@Component({ name: 'CreateCallbackDialog' })
export default class CreateCallbackDialog extends Vue {
  @Prop({ required: true, default: false }) state!: boolean;
  @Prop({ default: false }) loading!: boolean;
  @Prop({ default: () => [] }) merchants!: IMerchants[];

  valid: boolean = false;
  form: ICallbackBody = this.emptyForm();

  rules = {
    required: (value: string) => !!value || 'This field is required',
    // KairosKash validates with @IsUrl, so reject anything that isn't one here.
    url: (value: string) => /^https?:\/\/.+\..+/.test(value || '') || 'Enter a valid URL',
  };

  emptyForm(): ICallbackBody {
    return { appName: '', callbackUrl: '', credentialId: '' };
  }

  @Watch('state')
  onStateChange(open: boolean): void {
    if (!open) return;
    this.form = this.emptyForm();
    (this.$refs.form as Vue & { resetValidation: () => void })?.resetValidation();
  }

  @Emit('actions')
  close(payload: PayloadState) {
    return payload;
  }

  @Emit('save')
  save(): ICallbackBody {
    return { ...this.form };
  }
}
